<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.20075 0.949997L5.20075 3.16103H7.49491V5.15096H5.42207C5.29996 5.15096 5.20096 5.24995 5.20096 5.37206V7.44491H3.21103L3.21082 5.15096H1V3.16103H3.21082L3.21082 0.949997H5.20075Z"
      fill="currentColor"
    />
    <path
      d="M3.21103 16.5654V18.6383C3.21103 19.8594 4.20095 20.8493 5.42207 20.8493H7.49491V18.8594H5.42207C5.29996 18.8594 5.20096 18.7604 5.20096 18.6383V16.5654H3.21103Z"
      fill="currentColor"
    />
    <path
      d="M3.21103 14.078H5.20096V9.93232H3.21103V14.078Z"
      fill="currentColor"
    />
    <path
      d="M9.98232 3.16103V5.15096H14.128V3.16103H9.98232Z"
      fill="currentColor"
    />
    <path
      d="M16.6154 3.16103V5.15096H18.6883C18.8104 5.15096 18.9094 5.24995 18.9094 5.37206V7.44491H20.8993V5.37206C20.8993 4.15094 19.9094 3.16103 18.6883 3.16103H16.6154Z"
      fill="currentColor"
    />
    <path
      d="M20.8993 9.93232H18.9094V14.078H20.8993V9.93232Z"
      fill="currentColor"
    />
    <path
      d="M20.8993 16.5654H18.9094V18.6383C18.9094 18.7604 18.8104 18.8594 18.6883 18.8594H16.6154V20.8493H18.6883C18.763 20.8493 18.8368 20.8456 18.9096 20.8384V23.0603H20.8995V20.8493H23V18.8594H20.8884C20.8956 18.7866 20.8993 18.7129 20.8993 18.6383V16.5654Z"
      fill="currentColor"
    />
    <path
      d="M14.128 20.8493V18.8594H9.98232V20.8493H14.128Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Screenshot' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
